import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property, state, query, queryAll } from 'lit/decorators.js';
import { until } from 'lit/directives/until.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import '@vaadin/vaadin-accordion/vaadin-accordion';
import '@material/mwc-button';
import '../../common/loadingSpinner.js';
import { RxElement } from '../../common/reactiveX/rxElement.js';
import { subscribe } from '../../common/reactiveX/rxElementDecorators.js';
let FulfillmentArticles = class FulfillmentArticles extends RxElement {
    constructor() {
        super(...arguments);
        this.content = [];
        this.catFiltered = false;
        this.typeFiltered = false;
        this.limit = 12;
        this.page = 1;
        this.loaded = false;
        this.failed = false;
        this.paginationLimit = 11;
        this.paginationNumbers = [];
        this.typeMapping = [];
        this.categoryMapping = [];
        this.copyArticle = async (e) => {
            const id = e.target.getAttribute('data-id');
            const title = e.target.getAttribute('data-title');
            const slug = e.target.getAttribute('data-slug');
            const href = e.target.getAttribute('href');
            const copyHtml = `<a data-type="article" data-id="${id}" data-title="${title}" data-slug="${slug}" href="${href}" target="_blank">${title}</a>`;
            const blob = Promise.resolve(new Blob([copyHtml], { type: 'text/html' }));
            // eslint-disable-next-line no-undef
            const item = new ClipboardItem({ 'text/html': blob });
            await navigator.clipboard.write([item]);
            e.preventDefault();
        };
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        until(this.fetchArticles(), this.fetchCategories(), 'Loading...');
    }
    async fetchArticles() {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
        let url = `${process.env.RAFPRESS_API_URL}/articles?properties=c.id,c.slug,c.categories,c.title,c.client,c.exclude,c.region,c.language,c.type,c.modified&status=published`;
        const results = await fetch(new Request(url), {
            headers,
        });
        if (results.ok || results.status === 200) {
            const json = await results.json();
            let filtered = [];
            filtered = json.filter((j) => j.client &&
                (j.client.includes(this.account) || j.client.length === 0) &&
                !(j === null || j === void 0 ? void 0 : j.exclude.includes(this.account)) &&
                j.region === 'us' &&
                j.language === 'en');
            this.content = filtered;
            this.articles = filtered;
            this.allArticles = filtered;
            this.total = filtered.length;
            this.size = Math.ceil(filtered.length / this.limit);
            this.content.sort((a, b) => b.modified - a.modified);
            this.articles.sort((a, b) => b.modified - a.modified);
            this.allArticles.sort((a, b) => b.modified - a.modified);
            this.content = this.articles.slice((this.page - 1) * this.limit, this.page * this.limit);
            this.generatePageNumbers();
            this.buildFilters();
            this.loaded = true;
        }
        else {
            this.loaded = true;
            this.failed = true;
        }
        return null;
    }
    async fetchCategories() {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
        let url = `${process.env.RAFPRESS_API_URL}/categories?properties=c.id,c.slug,c.parentId,c.title,c.region,c.language,c.type,c.modified&status=published`;
        const results = await fetch(new Request(url), {
            headers,
        });
        if (results.ok || results.status === 200) {
            const json = await results.json();
            let filtered = json.filter((j) => j.region === 'us' && j.language === 'en' && j.type === 'category');
            this.categories = filtered;
        }
        else {
            this.loaded = true;
            this.failed = true;
        }
        return null;
    }
    searchArticles() {
        const search = this._search.value.toLowerCase().trim();
        this.page = 1;
        this.paginationNumbers = [];
        this.content = this.allArticles;
        if (search) {
            if (this.typeFiltered || this.catFiltered) {
                this.filterArticles();
                const obj = this.content.filter(o => o.title.toLowerCase().includes(search));
                this.size = Math.ceil(obj.length / this.limit);
                this.generatePageNumbers();
                this.content = obj.slice((this.page - 1) * this.limit, this.page * this.limit);
            }
            else {
                const obj = this.articles.filter(o => o.title.toLowerCase().includes(search));
                this.size = Math.ceil(obj.length / this.limit);
                this.generatePageNumbers();
                this.content = obj.slice((this.page - 1) * this.limit, this.page * this.limit);
            }
        }
        else {
            this.size = Math.ceil(this.articles.length / this.limit);
            this.generatePageNumbers();
            this.content = this.articles.slice((this.page - 1) * this.limit, this.page * this.limit);
        }
    }
    paginate(e) {
        const pageAttribute = e.target.getAttribute('data-page');
        const page = pageAttribute ? parseInt(pageAttribute, 10) : 1;
        if (Number.isNaN(page)) {
            return;
        }
        this.page = page;
        this.paginationNumbers = [];
        this.generatePageNumbers();
        this.content = this.articles.slice((this.page - 1) * this.limit, this.page * this.limit);
    }
    generatePageNumbers() {
        this.paginationNumbers = [];
        const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => (start + i * step).toString());
        if (this.size > this.paginationLimit) {
            const toPageLimit = this.size - this.page;
            const fromPageStart = this.page - 1;
            if (fromPageStart === 0 || fromPageStart <= this.paginationLimit - 4) {
                this.paginationNumbers.push(`0`);
                this.paginationNumbers.push(...range(1, this.paginationLimit - 3, 1));
                this.paginationNumbers.push(`...`);
                this.paginationNumbers.push(`${this.size - 1}`);
            }
            else if (toPageLimit === 0 || toPageLimit <= this.paginationLimit - 4) {
                this.paginationNumbers.push(`0`);
                this.paginationNumbers.push(`...`);
                this.paginationNumbers.push(...range(this.size - (this.paginationLimit - 2), this.size - 2, 1));
                this.paginationNumbers.push(`${this.size - 1}`);
            }
            else {
                if (toPageLimit === 1) {
                    this.paginationNumbers.push(`...`);
                    this.paginationNumbers.push(...range(this.size - (this.paginationLimit - 3), this.paginationLimit - 3, 1));
                }
                else if (fromPageStart === 1) {
                    this.paginationNumbers.push(`0`);
                    this.paginationNumbers.push(...range(this.page - 1, this.paginationLimit - 3, 1));
                    this.paginationNumbers.push(`...`);
                }
                else {
                    this.paginationNumbers.push(`0`);
                    this.paginationNumbers.push(`...`);
                    this.paginationNumbers.push(...range(this.page - 1 - 3, this.page - 1 + 3, 1));
                    this.paginationNumbers.push(`...`);
                }
                this.paginationNumbers.push(`${this.size - 1}`);
            }
        }
        else {
            [...Array(this.size).keys()].forEach(num => {
                this.paginationNumbers.push(`${num}`);
            });
        }
    }
    buildFilters() {
        this.allArticles.forEach(a => {
            if (a.type) {
                const name = a.type.charAt(0).toUpperCase() + a.type.slice(1);
                const filter = a.type;
                const { type } = a;
                const filterType = { name, filter, type };
                this.typeMapping.push(filterType);
            }
        });
        const cats = [];
        this.categories.forEach(c => {
            if (!c.parentId) {
                cats.push(c);
            }
        });
        this.categories.forEach(c => {
            if (c.parentId) {
                const find = cats.find((o) => o.id === c.parentId);
                if (find) {
                    const index = cats.findIndex((i) => i.id === find.id);
                    if (index) {
                        if (cats[index].children) {
                            cats[index].children.push(c);
                        }
                        else {
                            cats[index].children = [];
                            cats[index].children.push(c);
                        }
                    }
                }
            }
        });
        this.typeMapping = [...new Map(this.typeMapping.map(t => [t.filter, t])).values()];
        this.typeMapping.sort((a, b) => a.name.localeCompare(b.name));
        this.categoryMapping = cats.sort((a, b) => a.slug.localeCompare(b.slug));
    }
    filterArticles() {
        this.typeFiltered = false;
        let collect = [];
        this._checkboxes.forEach(c => {
            if (c.checked) {
                this.typeFiltered = true;
                const articles = this.allArticles.filter(a => a.type === c.value);
                collect = [...collect, ...articles];
            }
        });
        this.catFiltered = false;
        let catCollect = [];
        this._checkboxes.forEach(c => {
            if (c.checked) {
                if (c.name === 'category') {
                    this.catFiltered = true;
                    const articles = this.allArticles.filter(a => { var _a; return (_a = a.categories) === null || _a === void 0 ? void 0 : _a.includes(c.value); });
                    catCollect = [...catCollect, ...articles];
                }
            }
        });
        if (this.catFiltered) {
            collect = catCollect;
        }
        if (collect) {
            collect = collect.filter((value, index, self) => index === self.findIndex(t => t.id === value.id));
            collect.sort((a, b) => b.modified - a.modified);
            this.page = 1;
            this.paginationNumbers = [];
            this.articles = collect;
            this.total = this.articles.length;
            this.size = Math.ceil(this.total / this.limit);
            this.generatePageNumbers();
            this.content = this.articles.slice((this.page - 1) * this.limit, this.page * this.limit);
        }
        if (!this.typeFiltered && !this.catFiltered) {
            this.page = 1;
            this.paginationNumbers = [];
            this.articles = this.allArticles;
            this.total = this.allArticles.length;
            this.size = Math.ceil(this.total / this.limit);
            this.generatePageNumbers();
            this.content = this.articles.slice((this.page - 1) * this.limit, this.page * this.limit);
        }
    }
    clearFilters(e) {
        e.preventDefault();
        this._checkboxes.forEach(b => {
            // eslint-disable-next-line no-param-reassign
            b.checked = false;
        });
        this.page = 1;
        this.paginationNumbers = [];
        this.articles = this.allArticles;
        this.total = this.allArticles.length;
        this.size = Math.ceil(this.total / this.limit);
        this.generatePageNumbers();
        this.content = this.articles.slice((this.page - 1) * this.limit, this.page * this.limit);
    }
    dialogOpen(e) {
        e.preventDefault();
        this._dialog.showModal();
    }
    dialogClose(e) {
        e.preventDefault();
        this._dialog.close();
    }
    render() {
        if (this.loaded && this.failed) {
            return html `<p>Error Loading Articles</p>`;
        }
        if (!this.loaded && !this.content.length) {
            return html `<loading-spinner loadingText="Loading articles..."></loading-spinner>`;
        }
        return html `
			<div class="search__bar">
				<svg class="search__icon">
					<use href="/static/icons.svg#search" xlink:href="/static/icons.svg#search" />
				</svg>
				<input type="text" id="article__search" @keyup="${this.searchArticles}" />
				<div id="article__filter">
					<mwc-button
						raised
						label="filter"
						style="--mdc-theme-primary:#2C7FAD;--mdc-button-horizontal-padding:50px;"
						@click="${this.dialogOpen}"
					>
					</mwc-button>
				</div>
			</div>
			<div class="tab__content">
				${this.loaded && (!this.content || !this.content.length)
            ? html `<p>No Articles Found</p>`
            : html `<h4>Articles</h4>
							${this.content.map(article => html `
									<p class="article__entry">
										<a
											data-type="article"
											data-id="${article.id}"
											data-title="${article.title}"
											data-slug="${article.slug}"
											class="draggable article"
											draggable="true"
											target="_blank"
											href="${process.env.HUB_DOMAIN}/?redir=/library/${article.slug}"
											>${unsafeHTML(article.title)}</a
										>
										<span
											data-id="${article.id}"
											data-title="${article.title}"
											data-slug="${article.slug}"
											@click="${this.copyArticle}"
											@keyup="${this.copyArticle}"
											class="copy__article"
											href="${process.env.HUB_DOMAIN}/?redir=/library/${article.slug}"
											>Copy</span
										>
									</p>
								`)} `}
				<div class="paginate">
					<div class="paginate__numbers">
						${this.size
            ? (this.paginationNumbers,
                this.paginationNumbers.map(num => html `<span
											id="page${parseInt(num, 10) + 1}"
											data-page="${parseInt(num, 10) + 1}"
											@click="${this.paginate}"
											class="page__number ${parseInt(num, 10) + 1 === this.page
                    ? 'page__selected'
                    : ''}"
											@keyup="${this.paginate}"
											>${Number.isNaN(parseInt(num, 10)) ? num : parseInt(num, 10) + 1}</span
										>`))
            : ''}
					</div>
				</div>
			</div>
			<dialog id="filter__dialog">
				<div class="filter__header">
					<h1>Filters</h1>
				</div>
				<div class="filter__content">
					${this.typeMapping.length
            ? html `<div class="filter__filterGroup">
								<h2>Type</h2>
								${this.typeMapping.map(type => html `<div class="customField">
										<span class="type__checkbox"
											><input
												class="filter__checkbox"
												id="checkbox--${type.filter}"
												name="type"
												type="checkbox"
												data-indeterminate="false"
												aria-label="${type.name}"
												.value="${type.filter}"
												@change=${this.filterArticles} /></span
										><span class="type__label">${type.name}</span>
									</div>`)}
						  </div>`
            : ''}
					${this.categoryMapping.length
            ? html `<div class="filter__filterGroup">
								<h2>Categories</h2>
								<vaadin-accordion>
									${this.categoryMapping.map(cat => {
                var _a;
                return html `
											<vaadin-accordion-panel theme="reverse" style="border: none;">
												<div slot="summary" class="summary">
													<div class="customField">
														<span class="category__checkbox"
															><input
																class="filter__checkbox"
																id="checkbox--category"
																name="category"
																type="checkbox"
																data-indeterminate="false"
																aria-label="${cat.title}"
																.value="${cat.id}"
																@change=${this.filterArticles} /></span
														><span class="category__label">${cat.title}</span>
													</div>
												</div>
												<vaadin-vertical-layout>
													${(_a = cat.children) === null || _a === void 0 ? void 0 : _a.map((cc) => html `<div class="customField child__category">
															<span class="category__checkbox"
																><input
																	class="filter__checkbox"
																	id="checkbox--category"
																	name="category"
																	type="checkbox"
																	data-indeterminate="false"
																	aria-label="${cc.title}"
																	.value="${cc.id}"
																	@change=${this.filterArticles} /></span
															><span class="category__label">${cc.title}</span>
														</div>`)}
												</vaadin-vertical-layout>
											</vaadin-accordion-panel>
										`;
            })}
								</vaadin-accordion>
						  </div>`
            : ''}
				</div>
				<div class="filter__bottomControls">
					<mwc-button
						label="clear filter"
						style="--mdc-theme-primary:#2C7FAD;--mdc-theme-on-primary:#FFFFFF;--mdc-button-horizontal-padding:20px;"
						@click="${this.clearFilters}"
					>
					</mwc-button>
					<mwc-button
						raised
						label="done"
						style="--mdc-theme-primary:#2C7FAD;--mdc-button-horizontal-padding:50px;"
						@click="${this.dialogClose}"
					>
					</mwc-button>
				</div>
			</dialog>
		`;
    }
};
FulfillmentArticles.styles = css `
		:host {
			width: 100%;
		}
		.article__entry {
			width: 100%;
		}
		h4 {
			color: #073853;
			margin-left: 8px;
		}
		#article__search {
			width: 50%;
			height: 30px;
			margin: 8px 0 8px 20px;
			border-radius: 8px;
			border: 1px solid #d3d3d3;
			padding-left: 35px;
		}
		.search__bar {
			display: flex;
			justify-content: stretch;
			align-items: center;
			width: 100%;
			background: #f7f7fa;
			height: 50px;
			border-top: 1px solid #efefef;
			border-bottom: 1px solid #efefef;
		}
		#article__filter {
			width: 50%;
			height: 34px;
			margin: 8px 20px;
			display: flex;
			justify-content: flex-end;
		}
		.tab__content {
			padding: 0 20px 20px;
		}
		.article__entry {
			width: 100%;
			margin: 0;
			display: flex;
		}
		.article,
		.copy__article {
			display: inline-block;
			text-decoration: none;
			color: #007cab;
			font-weight: 500;
			margin: 8px 0 8px 8px;
			font-size: 14px;
			min-width: 40px;
			height: 100%;
		}
		.article {
			width: 100%;
		}
		.article__entry:nth-child(even) {
			background: #f7f7fa !important;
		}
		.paginate {
			width: 100%;
		}
		.paginate__numbers {
			text-align: center;
			font-size: 14px;
			margin-top: 10px;
		}
		.page__number {
			padding: 2px 6px;
			margin: 0 3px 0 0;
			cursor: pointer;
			user-select: none;
		}
		.page__selected {
			background: #077cab;
			border-radius: 50%;
			color: #fff;
		}
		.search__icon {
			height: 25px;
			width: 25px;
			vertical-align: middle;
			position: relative;
			margin-right: -57px;
			margin-left: 32px;
		}
		#filter__dialog {
			border-radius: 15px;
			box-shadow: 0 3px 6px #00000029;
			height: 500px;
			width: 600px;
			border: none;
			padding: 0;
		}
		.filter__header {
			align-items: baseline;
			border-bottom: 1px solid #efefef;
			color: #383838;
			display: flex;
			flex: 0 1 auto;
			justify-content: center;
			padding: 19px 22px;
		}
		.filter__header h1 {
			font-size: 20px;
			font-weight: 600;
			margin: 0;
		}
		.filter__content {
			max-height: 370px;
			overflow-y: auto;
			padding: 0 45px;
		}
		.filter__filterGroup {
			color: #383838;
			font-size: 15px;
			margin-top: 30px;
			padding-bottom: 30px;
		}
		.filter__filterGroup:not(:last-child) {
			border-bottom: 1px solid #efefef;
		}
		.filter__filterGroup h2 {
			font-size: 15px;
			font-weight: 600;
			margin-bottom: 22px;
		}
		.customField {
			display: flex;
			align-items: center;
		}
		.type__checkbox,
		.category__checkbox {
			padding: 4px;
			margin-left: -9px;
		}
		.filter__checkbox {
			width: 20px;
			height: 20px;
		}
		.type__label,
		.category__label {
			font-size: 15px;
			font-weight: 400;
			color: #000;
		}
		.child__category {
			margin: 0 0 0 25px;
		}
		.filter__bottomControls {
			align-items: flex-start;
			border-top: 1px solid #efefef;
			box-sizing: border-box;
			display: flex;
			flex: 0 1 125px;
			justify-content: space-between;
			padding: 14px 40px;
		}
		.copy__article {
			font-weight: 500;
			color: #007cab;
			cursor: pointer;
		}
	`;
__decorate([
    subscribe()
], FulfillmentArticles.prototype, "blueUser", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "advisee", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "hubSlug", void 0);
__decorate([
    state()
], FulfillmentArticles.prototype, "allArticles", void 0);
__decorate([
    state()
], FulfillmentArticles.prototype, "articles", void 0);
__decorate([
    state()
], FulfillmentArticles.prototype, "categories", void 0);
__decorate([
    state()
], FulfillmentArticles.prototype, "content", void 0);
__decorate([
    state()
], FulfillmentArticles.prototype, "catFiltered", void 0);
__decorate([
    state()
], FulfillmentArticles.prototype, "typeFiltered", void 0);
__decorate([
    query('#article__search')
], FulfillmentArticles.prototype, "_search", void 0);
__decorate([
    query('#filter__dialog')
], FulfillmentArticles.prototype, "_dialog", void 0);
__decorate([
    queryAll('.filter__checkbox')
], FulfillmentArticles.prototype, "_checkboxes", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "limit", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "page", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "loaded", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "failed", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "paginationLimit", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "paginationNumbers", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "account", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "size", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "total", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "typeMapping", void 0);
__decorate([
    property()
], FulfillmentArticles.prototype, "categoryMapping", void 0);
FulfillmentArticles = __decorate([
    customElement('fulfillment-articles')
], FulfillmentArticles);
export { FulfillmentArticles };
//# sourceMappingURL=articles.js.map